'use strict';

angular.module('ClinicApp').config(function($stateProvider) {
  $stateProvider.state('doctor.insurance', {
    url: 'insurance/',
    templateUrl: '/views/partials/doctor/insurance.html',
    controller: 'DoctorInsuranceCtrl',
    resolve: {
      pageTitle: function($pageTitle, doctor) {
        $pageTitle.set('Insurance - ' + doctor.name + ' - Opencare');
      },
    },
  });
});

angular.module('ClinicApp').controller('DoctorInsuranceCtrl', function() {});
